var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-card',{staticClass:"mb16"},[(_vm.basicInfoProps)?_c('contract-duty-amount',{attrs:{"id":_vm.basicInfoProps.contract_id}}):_vm._e()],1),(_vm.basicInfoProps.curr_step_num<_vm.stepInfo.stepNum && _vm.canEdit)?_c('footer-btn',{attrs:{"btnText":{
       okText: '保存'
     },"noCancelBtn":true},on:{"on-save":_vm.onSave}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }